import { css } from '@emotion/react';
import { ReactElement } from 'react';
import { useIntl } from 'react-intl';
import { ChatState } from 'sdk';

import { useSDK } from '../../../app';
import { styled, styledWithoutTheme } from '../../../styled';
import { Theme } from '../../../theme/interface/detailed';
import { Button } from '../../buttons';
import { msgs } from './msgs';

const GoBackButton = styledWithoutTheme((props: { className: string; children: string; onClick: VoidFunction }) => (
	<Button {...props} />
))(({ theme }: { theme: Theme }) => theme.chat.buttons.sendDialogToEmail.returnToMainScreenButton);

export const DialogSent = styled(({ className }: { className: string }): ReactElement => {
	const { uiStateStore } = useSDK();
	const { formatMessage } = useIntl();

	return (
		<div className={className}>
			<div className="txt">{formatMessage(msgs.dialogSent)}</div>
			<GoBackButton onClick={(): void => uiStateStore.setChatState(ChatState.chat)} className="btn">
				{formatMessage(msgs.goBack)}
			</GoBackButton>
		</div>
	);
})(css`
	align-items: center;
	display: flex;
	flex-flow: column;
	height: 100%;
	justify-content: center;

	& .txt {
		color: #222b55;
		font-size: 16px;
		font-weight: bold;
		letter-spacing: 0.1px;
		line-height: 24px;
	}

	& .btn {
		margin-top: 20px;
	}
`);
